/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeclineServiceLevelChangeRequest
 */
export interface DeclineServiceLevelChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof DeclineServiceLevelChangeRequest
     */
    reason: string;
}

/**
 * Check if a given object implements the DeclineServiceLevelChangeRequest interface.
 */
export function instanceOfDeclineServiceLevelChangeRequest(value: object): value is DeclineServiceLevelChangeRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function DeclineServiceLevelChangeRequestFromJSON(json: any): DeclineServiceLevelChangeRequest {
    return DeclineServiceLevelChangeRequestFromJSONTyped(json, false);
}

export function DeclineServiceLevelChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeclineServiceLevelChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function DeclineServiceLevelChangeRequestToJSON(value?: DeclineServiceLevelChangeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
    };
}

